module.exports = __webpack_public_path__ + "img/小满 (2).73bd4554.png";